module.exports = __webpack_public_path__ + "static/media/img_2.367de4fc.png";